import ObligationsDesk from "@/components/obligations/ObligationsDesk";

export default function Obligations() {
  return <ObligationsDesk />;
}
